import { InfoRow } from './InfoRow'
import { constants } from './Constants'
import { Box, Typography } from '@mui/material'
import { useAppSelector } from '../../app/hooks'
import { selectPatientInfo } from './ProrithmSlice'

const SelectedPatient = ({ mapTo }: { mapTo: string | undefined }) => {
  const patientInfo = useAppSelector(selectPatientInfo)
  if (!patientInfo) {
    return null
  }

  const infoFields = [
    {
      id: 'name',
      label: 'Name',
      value: `${patientInfo.firstName} ${patientInfo.lastName}`,
    },
    { id: 'patientId', label: 'Patient Id', value: patientInfo.muhId },
    { id: 'age', label: 'Age', value: patientInfo.age?.toString() },
    { id: 'gender', label: 'Gender', value: patientInfo.gender },
    { id: 'phone', label: 'Phone', value: patientInfo.phoneNumber },
  ]

  const ipdFields = [
    {
      id: 'name',
      label: 'Name',
      value: `${patientInfo.firstName} ${patientInfo.lastName}`,
    },
    { id: 'patientId', label: 'Patient Id', value: patientInfo.muhId },
    { id: 'age', label: 'Age', value: patientInfo.age?.toString() },
    { id: 'gender', label: 'Gender', value: patientInfo.gender },
    { id: 'phone', label: 'Phone', value: patientInfo.phoneNumber },
    { id: 'location', label: 'Location', value: patientInfo.locationName },
    { id: 'bedType', label: 'Bed Type', value: patientInfo.bedType },
    { id: 'ward', label: 'Ward', value: patientInfo.wardName },
    {
      id: 'room',
      label: 'Room',
      value: patientInfo.roomName,
    },
    { id: 'bed', label: 'Bed', value: patientInfo.bedName },
  ]

  return (
    <Box
      marginY={2}
      paddingX={2}
      borderRadius='4px'
      maxWidth='fit-content'
      border='1px solid grey'
    >
      <Typography variant='h6'>{constants?.selectedPatient}:</Typography>
      {mapTo === constants?.ipd ? (
        <>
          {ipdFields?.map(({ id, label, value }) => (
            <InfoRow key={id} label={label} value={value} />
          ))}
        </>
      ) : (
        <>
          {infoFields?.map(({ id, label, value }) => (
            <InfoRow key={id} label={label} value={value} />
          ))}
        </>
      )}
    </Box>
  )
}

export default SelectedPatient
